<template>
	<modal
		v-if="showDialog"
		v-model="showDialog"
		:title="$t('add-sip-user')"
		width="400"
		type="question"
		:confirm-text="$t('save')"
		:cancel-text="$t('cancel')"
		:is-cta-disable="isCtaDisable"
		:confirm-loading="loading"
		:show-save-icon="true"
		persistent
		content-class="devops-subdialog"
		show-close-button
		@cancel="showDialog = false"
		@confirm="handleSubmit"
	>
		<v-form ref="form" v-model="validForm" class="px-4" @submit.prevent="handleSubmit">
			<v-col class="pa-0">
				<v-text-field
					v-model="newUser.username"
					:rules="[rules.required(newUser.username, 'username'), rules.minLength(newUser.username), rules.maxLength(newUser.username), rules.userName(newUser.username)]"
					dense
					outlined
					background-color="light-primary"
					:label="$t('user-name-required')"
				/>
			</v-col>

			<v-col class="pa-0">
				<v-text-field
					v-model="newUser.displayName"
					:rules="[rules.required(newUser.displayName, 'displayName'), rules.minLength(newUser.displayName), rules.maxLength(newUser.displayName)]"
					dense
					outlined
					background-color="light-primary"
					:label="$t('display-name-required')"
				/>
				<span class="d-block text-caption text--secondary mt-n3 mb-1">{{ $t('sip-auto-password') }}</span>
			</v-col>

			<v-col class="pa-0">
				<div class="grey lighten-4 rounded pa-3 mt-2 mb-2">
					<div class="text-caption text--secondary text-center mb-2">
						{{ $t('sip-advanced-settings-hint') }}
					</div>

					<v-switch
						v-model="newUser.privateRecording"
						:label="$t('sip-private-recording')"
						class="mt-0 mb-0"
						dense
						hide-details
					/>

					<v-select
						v-model="newUser.defaultUserGroupId"
						:items="groupItems"
						:label="$t('sip-default-group')"
						:hint="$t('sip-default-group-hint')"
						persistent-hint
						dense
						outlined
						background-color="white"
						clearable
						class="mt-4"
						:no-data-text="$t('no-groups-available')"
					/>
				</div>
			</v-col>
		</v-form>
	</modal>
</template>

<script>
import Modal from "@/components/common/Modal.vue";
import { RequiredValidator } from "@/validators";

export default {
	name: "CreateSipUserDialog",
	components: { Modal },

	props: {
		value: Boolean,

		groups: {
			type: Array,
			default: () => []
		}
	},

	data: () => ({
		validForm: false,
		newUser: {
			username: undefined,
			displayName: undefined,
			privateRecording: false,
			defaultUserGroupId: null
		},
		loading: false,
		errors: []
	}),

	computed: {
		rules() {
			return {
				required: RequiredValidator,
				maxLength: value => !value || value.length <= 32 || this.$t("error.validator.maxLength", { maxLength: 32 }),
				minLength: value => !value || value.length >= 2 || this.$t("error.validator.minLength", { minLength: 2 }),
				userName: value => /^\+[\d]{11,12}$|^[\w.-]{1,32}$/.test(value) || this.$t("error.validator.sip-user-name")
			};
		},

		groupItems() {
			return this.groups.map(group => ({
				text: group.label || group.id,
				value: group.id
			}));
		},

		showDialog: {
			get() {
				return this.value;
			},

			set(value) {
				this.$emit("input", value);
			}
		},

		isCtaDisable() {
			return {
				cancel: this.loading,
				confirm: !this.validForm
			};
		}
	},

	watch: {
		showDialog(value) {
			!value && this.resetForm();
		}
	},

	methods: {
		async handleSubmit() {
			try {
				this.loading = true;

				await this.axios.post("/sips/v1/users", {
					username: this.newUser.username,
					displayName: this.newUser.displayName,
					privateRecording: this.newUser.privateRecording,
					defaultUserGroupId: this.newUser.defaultUserGroupId || undefined
				});
				this.$success(this.$t("create-sip-user-success"));
			} catch (error) {
				console.error(error);
				this.$error(this.$t("error.create-data"));
			} finally {
				this.loading = false;
				this.showDialog = false;
				this.resetForm();
				this.$emit("getUsers");
			}
		},

		resetForm() {
			this.$refs.form.reset();
		}
	}
};
</script>
